import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import {
  DialogContent,
  ListItem,
  Stack,
  styled,
  useTheme,
} from '@mui/material';

import { forwardRef, useImperativeHandle, useState } from 'react';

import { VscChromeClose } from '@react-icons/all-files/vsc/VscChromeClose';
import { HiOutlineArrowNarrowRight } from '@react-icons/all-files/hi/HiOutlineArrowNarrowRight';
import Link from 'next/link';

interface IModalInvestmentList {
  investmentList: {
    label: string;
    link: string;
  }[];
}

export const ModalInvestmentList = forwardRef(function ModalInvestmentList(
  { investmentList }: IModalInvestmentList,
  ref
) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setOpen(true);
    },
    closeModal: () => {
      setOpen(false);
    },
  }));

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth="sm"
      PaperProps={{
        sx: {
          background: '#f3f3f3',
        },
      }}
    >
      <DialogContent>
        <Stack
          flexDirection="row"
          gap={2}
          alignItems="start"
          justifyContent="space-between"
        >
          <Typography fontWeight={700} variant="body1" component="h3">
            Selecione uma das plataformas recomendadas pela gestora para
            investir no fundo:
          </Typography>

          <IconButton onClick={() => setOpen(false)}>
            <VscChromeClose size={20} color={theme.palette.primary.main} />
          </IconButton>
        </Stack>

        <List sx={{ mt: 4, backgroundColor: '#fff' }}>
          {investmentList?.map((investment, index) => (
            <StyledListItem key={investment.link}>
              <Link href={investment.link} target="_blank" rel="noopener">
                {investment?.label}
                <HiOutlineArrowNarrowRight size={16} />
              </Link>
            </StyledListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
});

const StyledListItem = styled(ListItem)`
  a {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f8f8f8;
    padding: 8px 16px 8px 16px;
    &:hover {
      background-color: #f8f8f8;
      text-decoration: none;
    }
  }
  &:first-child a {
    font-weight: 700;
  }
`;
